import React from 'react';

const SparkleDust: React.FC = () => {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden">
      {[...Array(20)].map((_, i) => (
        <div 
          key={i}
          className={`dust ${i % 2 === 0 ? 'bg-yellow-400 shadow-[0_0_8px_#fbbf24]' : i % 4 === 1 ? 'bg-purple-300 shadow-[0_0_6px_#d8b4fe]' : 'bg-white shadow-[0_0_6px_#fff]'}`}
          style={{
            width: `${Math.random() * 2 + 0.5}px`,
            height: `${Math.random() * 2 + 0.5}px`,
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            '--duration': `${Math.random() * 4 + 3}s`,
            '--delay': `${Math.random() * -10}s`,
            '--tx': `${(Math.random() - 0.5) * 100}px`,
            '--ty': `${(Math.random() - 0.5) * 100}px`,
          } as any}
        />
      ))}
    </div>
  );
};

export default SparkleDust;
